module.exports = __webpack_public_path__ + "static/media/office12.665c9aa5.png";